export const APP_VERSION = '1.0.2';
export const APP_BUILD_NUMBER = '1000200';

export const APP_FULL_VERSION = APP_VERSION + '.' + parseInt(APP_BUILD_NUMBER.substring(5), 10);

export const defaultApiServer = () => window.location.hostname.indexOf('cms-advcab-estimator.qmanisolutions.com') >= 0
    ? 'https://api-advcab-estimator.qmanisolutions.com'
    : 'https://api.xquest.test';
